import React from "react";

const MobileNavContext = React.createContext({});

export default MobileNavContext;
